import createCollectionResource from 'src/actions/shared/createResource';
import { HierarchicalItem } from 'src/lib/hierarchy';
import { IsNotEmpty, Matches, ValidateIf } from 'class-validator';
import { matchesError } from 'src/models/DomainError';
import { sortMergedTopics } from './topicsUtils';

export class Topic {
  id: string;
  disabled: boolean;

  @Matches(/\S/, { message: 'Please name your topic' })
  name: string;

  @ValidateIf(({ parentDropdownEnabled }) => parentDropdownEnabled === true)
  @IsNotEmpty({ message: 'Please select a parent topic' })
  parentId?: string;
}

export type HierarchicalTopic = HierarchicalItem<Topic>;

const topicsResource = createCollectionResource<Topic>({
  name: 'topics',
  endpoint: 'v1/orgs/:orgId/topics/:id',
  type: Topic,
  reducers: {
    dataMergeStarted(state) {
      state.dataMergeFinished = false;
    },
    dataMergeFinished(state, action) {
      state.dataMergeFinished = true;
      state.values = action.payload;
    },
  },
  observerCreator: ({ actions }) => {
    return ({ dispatch, getState }) => {
      return {
        onBroadcast(item) {
          dispatch(actions.broadcast(item));
          updateTopicsWithHierarchies(dispatch, getState);
        },
      };
    };
  },
  options: {
    getErrorMessage: err => {
      if (matchesError(err, { attr: 'name', code: 'taken' })) {
        return 'Another topic already has this name. Please choose a unique name, or nest it under a different parent.';
      }
    },
  },
});

export function updateTopicsWithHierarchies(dispatch, getState) {
  const state = getState();
  const topics = sortMergedTopics(state);
  dispatch(topicsResource.actions.dataMergeFinished(topics));
}

export default topicsResource;
